import { AxiosError, isAxiosError } from 'axios';

export const isConnectionAborted = (error: unknown) =>
  isAxiosError(error) && error.code === AxiosError.ECONNABORTED;
